import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject
export class PageResult<T=any>{
  @JsonProperty('content', [])
  content: T[] = [];

  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  sort: any;
  totalElements: number;

  @JsonProperty('totalPages', Number)
  totalPages: number = undefined;
}
